
import { Vue, Component, Watch } from 'vue-property-decorator'
import { setCollectConfig, getCollectConfig } from '@/api/order/topupOrder'
import { AppModule } from '@/store/modules/app'
import {
  walletDetails,
  queryAddress,
  getStakeWallet,
  getStakeRecord,
  unfreezePledge,
  setBatchCollect,
  getProductList,
  setWithdrawBalance
} from '@/api/product/product'
import walletAddressLog from './walletAddressLog.vue'
import pagination from '@/components/Pagination/index.vue'
import addPledge from './createPledge.vue'
import { clipboardSuccess } from '@/utils/clipboard'
// import { getProductList } from '@/api/product/product'
import { getProductAccountList } from '@/api/product/productAccount'
import { dateToSeconds, getCurrentDate, pickerOptions } from '@/utils/dateTime'
import { mixins } from 'vue-class-component'
import currencyOptionMixin from '@/mixin/currencyOption'
import Pledge from './pledge.vue'
import { checkPermission } from '@/utils/permission'

@Component({
  name: 'guiji',
  components: {
    walletAddressLog,
    pagination,
    addPledge,
    Pledge
  }
})
export default class extends mixins(currencyOptionMixin) {
  get language() {
    return AppModule.language
  }
  private activeName: any = '1'
  private availableCurrency: any = []
  private clipboardSuccess() {
    this.$message({
      message: 'Copy successfully',
      type: 'success',
      duration: 2000
    })
  }
  private walletType: any = 'trc20'
  private infoForm: any = {
    hidden_config: {},
    google_code: ''
  }

  private loading: boolean = false
  private flag: boolean = false
  // 按钮只触发一次
  private flagStr() {
    setTimeout(() => {
      this.flag = false
    }, 500)
  }

  @Watch('walletType', { immediate: true })
  private watchType(newVal) {
    if (this.walletType === 'trc20') {
      this.infoForm.google_code = ''
      if (this.trc20Info.fee_wallet) {
        this.infoForm.hidden_config = {
          trc20: {
            collect_wallet: this.trc20Info.collect_wallet,
            // fee_wallet: '',
            fee_wallet: this.trc20Info.fee_wallet,
            fee_limit: this.trc20Info.fee_limit,
            min_collect_amount: this.trc20Info.min_collect_amount,
            collect_by_stake: this.trc20Info.collect_by_stake
          }
        }
      } else {
        this.infoForm.hidden_config = {
          trc20: {
            collect_wallet: '',
            fee_wallet: '',
            fee_limit: '',
            min_collect_amount: '',
            collect_by_stake: true
          }
        }
      }
    } else {
      this.infoForm.google_code = ''
      if (this.erc20Info.fee_wallet) {
        this.infoForm.hidden_config = {
          erc20: {
            collect_wallet: this.erc20Info.collect_wallet,
            fee_wallet: this.erc20Info.fee_wallet,
            fee_limit: this.erc20Info.fee_limit,
            min_collect_amount: this.erc20Info.min_collect_amount,
            collect_gas_price: this.erc20Info.collect_gas_price
          }
        }
      } else {
        this.infoForm.hidden_config = {
          erc20: {
            collect_wallet: '',
            fee_wallet: '',
            fee_limit: '',
            min_collect_amount: '',
            collect_gas_price: ''
          }
        }
      }
    }
  }

  private back() {
    if (this.walletType === 'trc20') {
      this.infoForm.hidden_config = {
        trc20: {
          collect_wallet: '',
          fee_wallet: '',
          fee_limit: '',
          min_collect_amount: '',
          collect_by_stake: true
        }
      }
    } else {
      this.infoForm.hidden_config = {
        erc20: {
          collect_wallet: '',
          fee_wallet: '',
          fee_limit: '',
          min_collect_amount: '',
          collect_gas_price: ''
        }
      }
    }
    this.$emit('close')
  }

  // 钱包地址 查询
  private async query(row: any) {
    try {
      this.listLoading = true
      let data: any = {
        address: row
      }
      await queryAddress(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'Query successfully!',
            type: 'success'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '查询成功!',
            type: 'success'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '查詢成功!',
            type: 'success'
          })
        }
        this.listLoading = false
        this.flagStr()
      })
    } catch (e) {}
    this.listLoading = false
  }

  // 质押钱包统计
  private erc20Info: any = {}
  private trc20Info: any = {}
  private async stakeWallet() {
    try {
      await getCollectConfig().then((res: any) => {
        if (res.hidden_config.erc20) {
          this.erc20Info = res.hidden_config.erc20
        }
        if (res.hidden_config.trc20) {
          this.trc20Info = res.hidden_config.trc20
          this.infoForm.hidden_config = {
            trc20: {
              collect_wallet: this.trc20Info.collect_wallet,
              fee_wallet: this.trc20Info.fee_wallet,
              fee_limit: this.trc20Info.fee_limit,
              min_collect_amount: this.trc20Info.min_collect_amount,
              collect_by_stake: this.trc20Info.collect_by_stake
            }
          }
          if (this.trc20Info.collect_by_stake === false) {
            this.infoForm.hidden_config.trc20.collect_by_stake =
              this.trc20Info.collect_by_stake
          } else {
            this.infoForm.hidden_config.trc20.collect_by_stake = true
          }
        } else {
          this.infoForm.hidden_config = {
            trc20: {
              collect_wallet: '',
              fee_wallet: '',
              fee_limit: '',
              min_collect_amount: '',
              collect_by_stake: true
            }
          }
        }
      })
    } catch (e) {}
  }

  private async save() {
    try {
      this.loading = true
      this.flag = true
      const data: any = {
        ...this.infoForm
      }
      await setCollectConfig(data).then(() => {
        this.$message({
          message: 'Save successful!',
          type: 'success'
        })
        this.loading = false
        this.stakeWallet()
        this.walletType = 'trc20'
        this.flagStr()
      })
    } catch (e) {
      this.loading = false
      // this.back()
    }
  }

  private changeTabs(val: any) {
    if (val.name === '2') {
      this.queryForm.currency = this.currentCurrency
      this.hadleGetFilesListApi()
    } else if (val.name === '3') {
      this.autoRecordList = []
      this.manuaRecordList = []
      this.getStakeWalletData()
      this.resetPledge()
    } else if (val.name === '4') {
      this.manuaRecordList = []
      this.autoRecordList = []
      this.resetManualPledge()
      this.getProductLists()
    }
  }
  // 分页器设置
  private pagesize: number = 20
  private handleSizeChange(size) {
    this.pagesize = size
    this.hadleGetFilesListApi()
  }

  // 分页切换
  private currentPage: number = 1
  private handleCurrentChange(currentPage) {
    this.currentPage = currentPage
    this.hadleGetFilesListApi()
  }

  private changeAmount() {
    this.form.min_coin_amount = null
    this.form.max_coin_amount = null
    this.form.min_amount = null
    this.form.max_amount = null
  }
  private copy() {
    this.$message({
      message: 'Copy successfully',
      type: 'success'
    })
  }

  private dialogVisible: boolean = false
  private handleSelectionChange(list) {
    this.selectList = list
  }
  private batchCollectList: any[] = []
  private batchCollect() {
    this.batchCollectList = []
    for (let i = 0; i < this.selectList.length; i++) {
      if (this.selectList[i]) {
        this.batchCollectList.push(this.selectList[i].address)
      }
    }
    this.dialogVisible = true
  }
  private closeDialogVisible() {
    this.dialogVisible = false
    this.hadleGetFilesListApi()
  }
  private select() {
    this.currentPage = 1
    this.hadleGetFilesListApi()
  }
  private async saveBatchCollect() {
    try {
      this.loading = true
      const data: any = {
        wallets: this.batchCollectList
      }
      await setBatchCollect(data).then(() => {
        if (this.language === 'en') {
          this.$message({
            message: 'Operation successfully!',
            type: 'success'
          })
        } else if (this.language === 'zh_cn') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        } else if (this.language === 'zh_tw') {
          this.$message({
            message: '操作成功!',
            type: 'success'
          })
        }
        this.loading = false
        this.closeDialogVisible()
      })
    } catch (e) {}
  }

  private walletDetailsList: any = []
  private walletId: any = ''
  private accountType: any = ''
  private walletAddressList: any = []
  private listLoading: boolean = false
  private form: any = {
    currency: null,
    account_type: null,
    address: null,
    min_amount: null,
    max_amount: null,
    min_coin_amount: null,
    max_coin_amount: null
  }
  queryForm: any = {
    product_code: '',
    product_account_no: '',
    record_type: '',
    start_time: null,
    end_time: null,
    unfreeze_start_time: null,
    unfreeze_end_time: null
  }
  private total = {}
  private totalData: any = {}
  private autoRecordTotal = {}
  private manualRecordTotal = {}
  private amountType: string = 'Paid Amount'
  private selectList: any[] = []
  private drawer: boolean = false
  private newArr: any = []

  private open(row: any) {
    this.walletId = row.id
    this.accountType = row.account_type
    this.drawer = true
  }
  private closeDrawer(isManual: boolean = false) {
    if (isManual) {
      this.drawer = false
    }
    this.hadleGetFilesListApi()
  }
  private hashJump(row) {
    if (row.account_type === 'trc20') {
      window.open(`https://tronscan.io/#/address/${row.address}`)
    } else if (row.account_type === 'erc20') {
      window.open(`https://etherscan.io/address/${row.address}`)
    }
  }

  private hashJumpRecord(row) {
    window.open(`https://tronscan.io/#/transaction/${row}`)
  }

  private autoJumpRecord(row) {
    window.open(`https://tronscan.io/#/address/${row}`)
  }

  // 对所有数据进行分页处理 发送请求
  private async hadleGetFilesListApi() {
    try {
      this.listLoading = true
      let data: any = {
        ...this.form,
        currency: this.queryForm.currency,
        page_size: this.pagesize,
        page: this.currentPage,
        wallet_type: 'ant'
      }
      await walletDetails(data).then((res: any) => {
        this.total = res
        this.walletDetailsList = res.results
        this.totalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {}
  }

  private addAgencyVisible: boolean = false
  private openAddAgency() {
    this.addAgencyVisible = true
  }
  private closeAgency() {
    this.addAgencyVisible = false
    this.stakeWallet()
    this.getAutoRecordList()
  }

  private shareVisible: any = false
  // 提取冻结金额saveShare
  private withdrawalFrozen() {
    this.shareVisible = true
  }
  private closeShare() {
    this.shareVisible = false
  }
  private async saveShare() {
    try {
      await setWithdrawBalance().then((res: any) => {
        this.$message.success(
          'The frozen amount has been withdrawn successfully'
        )
        this.manuaRecordList = []
        this.autoRecordList = []
        this.resetManualPledge()
        this.getProductLists()
        this.shareVisible = false
      })
    } catch (e) {
      this.shareVisible = false
    }
  }

  private pickerOptions = pickerOptions
  private dateType: any = 'Created Time'
  private createdDate: any[] = getCurrentDate()
  private unfreezeDate: any[] = []
  private dateChange(e: any) {
    if (e === 'Unfreeze Time') {
      this.unfreezeDate = getCurrentDate()
      this.unfreezeTimeChange()
    } else {
      this.createdDate = getCurrentDate()
      this.createdTimeChange()
    }
  }

  private unfreezeTimeChange() {
    if (this.unfreezeDate) {
      this.queryForm.unfreeze_start_time = dateToSeconds(this.unfreezeDate[0])
      this.queryForm.unfreeze_end_time = dateToSeconds(this.unfreezeDate[1])
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    } else {
      this.queryForm.unfreeze_start_time = null
      this.queryForm.unfreeze_end_time = null
    }
  }

  @Watch('createdDate', { immediate: true })
  private createdTimeChange() {
    if (this.createdDate) {
      this.queryForm.start_time = dateToSeconds(this.createdDate[0])
      this.queryForm.end_time = dateToSeconds(this.createdDate[1])
      this.queryForm.unfreeze_start_time = null
      this.queryForm.unfreeze_end_time = null
    } else {
      this.queryForm.start_time = null
      this.queryForm.end_time = null
    }
  }

  private pledgeForm: any = {
    status: 1
  }

  // 解冻
  private unfreezePledge: boolean = false
  private unfreezeID: any = null
  private openEdit(row) {
    this.unfreezeID = row
    this.unfreezePledge = true
  }
  private closeUnfreeze() {
    this.unfreezePledge = false
    this.getStakeWalletData()
    this.getAutoRecordList()
  }
  private async unfreezeSave() {
    try {
      this.flag = true
      const data: any = {
        id: this.unfreezeID,
        status: this.pledgeForm.status
      }
      await unfreezePledge(data).then(() => {
        this.$message({
          message: 'Create Successful!',
          type: 'success'
        })
        this.closeUnfreeze()
        this.flagStr()
      })
    } catch (e) {
      this.flagStr()
    }
  }

  // 质押钱包统计
  private trc20DataInfo: any = {}
  private async getStakeWalletData() {
    try {
      await getStakeWallet().then((res: any) => {
        this.trc20DataInfo = res.trc20
      })
    } catch (e) {}
  }
  // 自动质押记录分页器
  private recordsize: number = 0
  private recordSizeChange(size) {
    this.recordsize = size
    this.getAutoRecordList()
  }
  // 自动质押记录分页切换
  private recordPage: number = 1
  private recordCurrentChange(currentPage) {
    this.recordPage = currentPage
    this.getAutoRecordList()
  }
  // 自动质押记录列表
  private autoRecordList: any[] = []
  private autoTotalData: any = {}
  private async getAutoRecordList() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        record_type: 'auto',
        page_size: this.recordsize,
        page: this.recordPage
      }
      await getStakeRecord(data).then((res: any) => {
        this.autoRecordTotal = res
        this.autoRecordList = res.results
        this.autoTotalData = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }
  // 自动质押记录搜索
  private selectPledge() {
    this.recordPage = 1
    this.getAutoRecordList()
  }
  // 自动质押记录清空
  private resetPledge() {
    this.queryForm = {
      status: '',
      address: '',
      record_type: 'auto',
      start_time: null,
      end_time: null
    }
    this.dateType = 'Created Time'
    this.createdDate = getCurrentDate()
    this.unfreezeDate = getCurrentDate()
    this.recordPage = 1
    this.$nextTick(() => {
      this.getAutoRecordList()
    })
  }

  // 手动质押记录分页器
  private manualRecord(size) {
    this.recordsize = size
  }
  // 手动质押记录分页切换
  private manualRecordChange(currentPage) {
    this.recordPage = currentPage
  }
  // 手动质押记录列表
  private manuaRecordList: any[] = []
  private manuaRecordTotal: any = {}
  private async getManuaRecordList() {
    try {
      this.listLoading = true
      const data: any = {
        ...this.queryForm,
        record_type: 'manual',
        page_size: this.recordsize,
        page: this.recordPage
      }
      await getStakeRecord(data).then((res: any) => {
        this.manualRecordTotal = res
        this.manuaRecordList = res.results
        this.manuaRecordTotal = res.total_data
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }
  // 手动质押记录查询
  private selectManualPledge() {
    this.recordPage = 1
    this.getManuaRecordList()
  }
  // 手动质押记录清空
  private resetManualPledge() {
    this.queryForm = {
      product_code: '',
      product_account_no: '',
      record_type: 'manual'
    }
    this.dateType = 'Created Time'
    this.createdDate = getCurrentDate()
    this.unfreezeDate = getCurrentDate()
    this.recordPage = 1
    this.$nextTick(() => {
      this.getManuaRecordList()
    })
  }

  // 打开创建质押钱包弹窗
  private addPledgeVisible: boolean = false
  private openAdd() {
    this.addPledgeVisible = true
  }
  private closePledge() {
    this.addPledgeVisible = false
    this.getStakeWalletData()
    this.getAutoRecordList()
  }

  private reset() {
    this.form = {
      address: null,
      min_amount: null,
      max_amount: null
    }
    this.currentPage = 1
    this.$nextTick(() => {
      this.hadleGetFilesListApi()
    })
  }

  // 获取产品列表
  private productList: any = []
  private async getProductLists() {
    const data: any = {
      currency: 'USDT',
      status: 1
    }
    await getProductList(data).then((res: any) => {
      this.productList = res
    })
  }

  private changeProduct(e: any) {
    this.queryForm.product_account_no = null
    this.getProductAccount()
  }

  // 获取产品账户
  private productAccount: any = []
  private async getProductAccount() {
    const data: any = {
      product_code: this.queryForm.product_code
    }
    await getProductAccountList(data).then((res: any) => {
      this.productAccount = res.results
    })
  }

  // 产品切换
  private selProduct() {
    AppModule.SetCurrentCurrencyType(this.queryForm.currency)
    this.hadleGetFilesListApi()
  }
  // 获取切换的货币的值
  private async getEnterprise() {
    // this.queryForm.currency = 'USDT'
    this.hadleGetFilesListApi()
  }

  private currentCurrency: any = null
  mounted() {
    this.currentCurrency = AppModule.enterprise.available_currency.find(
      item => item === 'USDT'
    )
    if (checkPermission('set_Imputation_config')) {
      this.activeName = '1'
    } else if (
      checkPermission('set_Imputation_config') === false &&
      checkPermission('collect_wallet_address_list')
    ) {
      this.activeName = '2'
      this.queryForm.currency = this.currentCurrency
    }

    this.stakeWallet()
    this.getStakeWalletData()
  }
}
